import { hasOwn } from '../hasOwn';
import { isValidEmail } from '../isValidEmail';

import { ValidationError } from './ValidationError';

const SLUG_MIN_LENGTH = 4;
export const SLUG_MAX_LENGTH = 40;
const ALPHANUMERIC_VALIDATION = /^[-a-zA-Z0-9]+$/;
const TITLE_MAX_LENGTH = 90;

export type Account = {
  name?: string;
  email?: string;
  subdomain?: string;
  subdomainTitle?: string;
};

type Options = {
  allowPartial?: boolean;
};

export function validateAccount(account: Account, options: Options = {}) {
  const { name, email, subdomain, subdomainTitle } = account;
  const { allowPartial = false } = options;
  if (!allowPartial || hasOwn(account, 'name')) {
    if (!name) {
      throw new ValidationError('Field "{field}" cannot be empty', {
        field: 'name',
      });
    }
  }
  if (!allowPartial || hasOwn(account, 'email')) {
    if (!email || !isValidEmail(email)) {
      throw new ValidationError('Field "{field}" is not valid', {
        field: 'email',
      });
    }
  }
  if (!allowPartial || hasOwn(account, 'subdomain')) {
    if (!subdomain || subdomain.length < SLUG_MIN_LENGTH) {
      throw new ValidationError(
        'Field "{field}" must be at least {length} characters in length',
        { field: 'subdomain', length: SLUG_MIN_LENGTH },
      );
    }
    if (subdomain.length > SLUG_MAX_LENGTH) {
      throw new ValidationError(
        'Field "{field}" must be no more than {length} characters in length',
        { field: 'subdomain', length: SLUG_MAX_LENGTH },
      );
    }
    if (!ALPHANUMERIC_VALIDATION.test(subdomain)) {
      throw new ValidationError('Field "{field}" contains invalid characters', {
        field: 'subdomain',
      });
    }
  }
  if (!allowPartial || hasOwn(account, 'subdomainTitle')) {
    if (subdomainTitle && subdomainTitle.length > TITLE_MAX_LENGTH) {
      throw new ValidationError(
        'Field "{field}" must be no more than {length} characters in length',
        { field: 'title', length: TITLE_MAX_LENGTH },
      );
    }
  }
}
